"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @enum {string}
 * @alias CollapsibleLink.arrowPositions
 * @desc Enum for the different options for CollapsibleLink arrow position.
 * Add className {CollapsibleLink.arrowPositions.LEFT} for positioning the toggle arrow to the left of the title.
 * Add className {CollapsibleLink.arrowPositions.RIGHT} for positioning the toggle arrow to the right of the title.
 * Add className {CollapsibleLink.arrowPositions.NONE} to display without an arrow.
 */
var arrowPositions = {
  /** left */
  LEFT: "left",

  /** right */
  RIGHT: "right",

  /** none */
  NONE: "none"
};
/**
 * @callback CollapsibleLink~onToggle
 * @param {boolean} expanded
 *     Current expanded/collapsed state
 */

/**
 * @class CollapsibleLink
 * @desc Simple link which expand/collapse on click. Link contains two states: expand and collapse.
 * Default state of link is collapse.
 *
 * @param {string} [data-id="collapsible-link"]
 *     To define the base "data-id" value for top-level HTML container.
 * @param {string} [className]
 *     CSS classes to set on the top-level HTML container.
 *
 * @param {object|string} [title]
 *     Text of link.
 * @param {string} [toggledTitle]
 *     Text of link when state change. When toggledTitle is specified, title becomes title of link if link is
 *     collapsed and toggledTitle becomes title of link if link is expanded.
 *
 * @param {CollapsibleLink.arrowPositions} [arrowPosition=CollapsibleLink.arrowPositions.RIGHT]
 *     Enum to specify where the arrow is positioned relative to the the title.
 *
 * @param {boolean} [expanded=false]
 *     Indicate whether link is in expanded state or collapsed state. Default is in collapsed state.
 *
 * @param {boolean} [disabled=false]
 *     Grays out link and doesn't accept clicks
 *
 * @param {CollapsibleLink~onToggle} [onToggle]
 *     Callback to be executed when toggle state of link is changed.
 *
 * @example
 *     <CollapsibleLink
 *           data-id="my-link"
 *           title="Text when link is collapsed"
 *           toggledTitle="Text when link is expanded"
 *           onToggle={this._toggle}
 *           expanded={this.state.isOpen}>
 *     </CollapsibleLink>
 */

var CollapsibleLink = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(CollapsibleLink, _React$Component);

  var _super = _createSuper(CollapsibleLink);

  function CollapsibleLink() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, CollapsibleLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleToggle", function () {
      if (_this.props.onToggle) {
        // do callback in case it has passed callback function.
        _this.props.onToggle();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(CollapsibleLink, [{
    key: "render",
    value: function render() {
      var className = (0, _classnames.default)("collapsible-link", this.props.className, this.props.arrowPosition, {
        open: this.props.expanded,
        "collapsible-link--disabled": this.props.disabled,
        "collapsible-link--no-spacing": this.props.noSpacing
      });
      var title = this.props.toggledTitle && this.props.expanded ? this.props.toggledTitle : this.props.title;
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": this.props["data-id"],
        className: className,
        onClick: this._handleToggle
      }, title);
    }
  }]);
  return CollapsibleLink;
}(_react.default.Component);

(0, _defineProperty2.default)(CollapsibleLink, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  toggledTitle: _propTypes.default.string,
  arrowPosition: _propTypes.default.oneOf(["left", "right", "none"]),
  expanded: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onToggle: _propTypes.default.func,
  noSpacing: _propTypes.default.bool
});
(0, _defineProperty2.default)(CollapsibleLink, "defaultProps", {
  "data-id": "collapsible-link",
  arrowPosition: "right",
  expanded: false,
  disabled: false,
  noSpacing: false
});
CollapsibleLink.arrowPositions = arrowPositions;
module.exports = CollapsibleLink;